import Vue from 'vue'

const LOCALE_KEY = 'hrws_locale'

/** IE / 360 兼容模式下 localStorage 可能因安全区域、隐私策略抛出 SecurityError（SCRIPT5022） */
function safeGetItem(key) {
  try {
    if (typeof localStorage === 'undefined') return null
    return localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

function safeSetItem(key, value) {
  try {
    if (typeof localStorage === 'undefined') return
    localStorage.setItem(key, value)
  } catch (e) {
    /* ignore SecurityError / QuotaExceeded */
  }
}

const messages = {
  'zh-CN': {
    titles: {
      default: '湖州互荣万顺特材科技有限公司',
      home: '湖州互荣万顺特材科技有限公司',
      about: '关于互荣万顺 - 湖州互荣万顺特材科技有限公司',
      products: '产品中心 - 湖州互荣万顺特材科技有限公司',
      productItem: '产品详情 - 湖州互荣万顺特材科技有限公司',
      landingEp: 'EP洁净管 - 湖州互荣万顺特材科技有限公司',
      landingBa: 'BA光亮管 - 湖州互荣万顺特材科技有限公司',
      landingSquareRect: '不锈钢无缝方矩管 - 湖州互荣万顺特材科技有限公司',
      applications: '应用领域 - 湖州互荣万顺特材科技有限公司',
      quality: '质量保障 - 湖州互荣万顺特材科技有限公司',
      news: '行业资讯 - 湖州互荣万顺特材科技有限公司',
      contact: '联系我们 - 湖州互荣万顺特材科技有限公司',
      privacy: '隐私与免责声明 - 湖州互荣万顺特材科技有限公司'
    },
    meta: {
      description: {
        default: '湖州互荣万顺特材科技有限公司主营不锈钢无缝方矩管、BA光亮管、EP电解抛光洁净管（304/316L），直管供货，外径可至114mm；支持定尺与资料配套，面向全国终端快速报价。',
        home: '湖州互荣万顺特材主营不锈钢无缝方矩管、BA光亮管、EP电解抛光洁净管（304/316L），直管供货，外径可至114mm；EP Ra 0.2–0.4、BA Ra 0.4–0.8。支持定尺与资料配套，面向全国终端快速报价。',
        about: '了解湖州互荣万顺特材：不锈钢无缝方矩管、BA光亮管、EP电解抛光洁净管等产品方向与交付理念；支持按需求沟通规格、资料与交期。',
        products: '浏览不锈钢与合金管材、管件等产品目录，并查看 BA/EP 工艺流程示意；如需不锈钢无缝方矩管、BA管、EP洁净管选型与交付建议，欢迎联系咨询。',
        productItem: '查看产品分类的常用牌号、标准与应用领域简介；支持按项目需求沟通规格、公差、表面状态与资料配套。',
        landingEp: 'EP电解抛光不锈钢洁净管（直管供货），常用316L/304，内表面 Ra 0.2–0.4，外径可至114mm；适用于半导体/高纯气体/化学品及洁净系统配管。支持定尺与资料配套，面向全国终端快速报价。',
        landingBa: 'BA光亮退火不锈钢无缝管（直管供货），304/316L为主，内表面 Ra 0.4–0.8，外径可至114mm；适用于水冷机房洁净配管、仪表气路与设备配套等。支持定尺与资料配套，全国快速响应。',
        landingSquareRect: '不锈钢无缝方矩管（304/316L）按需求定制与定尺交付，适用于设备机架、支架管廊与工程配套结构件等。支持按图纸/清单报价，资料配套按订单约定，面向全国终端快速响应。',
        applications: '查看不锈钢与合金管材在洁净管道、工艺管线、换热与装备制造等场景的应用方向；支持按工况选型与交付建议。',
        quality: '质量保障与交付说明：按订单约定提供材质证明与检验资料配套，并关注批次追溯、尺寸一致性与交付节点可控。',
        news: '行业资讯与市场观察：关注不锈钢现货与应用趋势，了解材料与交付侧的关键变化。',
        contact: '联系湖州互荣万顺特材获取报价与选型建议：请提供材质、规格、壁厚、长度、数量、用途/介质与交期，我们将尽快反馈。',
        privacy: '隐私与免责声明说明：了解本站信息使用、数据处理与免责声明条款。'
      }
    },
    common: {
      menu: '菜单',
      langZh: '中文',
      langEn: 'EN'
    },
    nav: {
      home: '首页',
      about: '关于互荣万顺',
      products: '产品中心',
      applications: '应用领域',
      quality: '质量保障',
      news: '行业资讯',
      contact: '联系我们'
    },
    footer: {
      company: '湖州互荣万顺特材科技有限公司',
      rights: 'hzhrws.com 版权所有 · 业务方向：不锈钢无缝方矩管 / BA不锈钢无缝管 / EP不锈钢管道',
      privacy: '隐私与免责声明'
    }
  },
  'en-US': {
    titles: {
      default: 'Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      home: 'Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      about: 'About HRWS - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      products: 'Products - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      productItem: 'Product Details - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      landingEp: 'EP Clean Tubing - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      landingBa: 'BA Bright Annealed Tubing - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      landingSquareRect: 'Seamless Square & Rectangular Tubes - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      applications: 'Applications - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      quality: 'Quality Assurance - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      news: 'Industry Insights - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      contact: 'Contact Us - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      privacy: 'Privacy & Disclaimer - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.'
    },
    meta: {
      description: {
        default: 'HRWS supplies stainless solutions including seamless square/rectangular tubes, BA bright annealed tubing and EP electropolished clean tubing (304/316L). Straight-length supply up to OD 114 mm, cut-to-length available with documentation support.',
        home: 'HRWS supplies stainless solutions including seamless square/rectangular tubes, BA bright annealed tubing and EP electropolished clean tubing (304/316L). Straight-length supply up to OD 114 mm with documentation support for project delivery.',
        about: 'Learn about HRWS and our stainless tubing capabilities. We support project discussions on sizes, tolerances, surface condition and documentation packages.',
        products: 'Browse tubing and fittings categories and review BA/EP process flows. Contact us for selection guidance and delivery planning for seamless square/rectangular tubes, BA and EP tubing.',
        productItem: 'View common grades, standards and applications for each category. Project-specific sizes, tolerances, surface requirements and documentation can be discussed upon request.',
        landingEp: 'EP electropolished clean tubing in straight lengths (316L/304), inner Ra 0.2–0.4, up to OD 114 mm. Designed for high-purity gas/chemical distribution and clean utility piping. Cut-to-length with documentation support.',
        landingBa: 'BA bright annealed seamless tubing in straight lengths (304/316L), inner Ra 0.4–0.8, up to OD 114 mm. Suitable for clean piping, instrumentation and equipment integration. Cut-to-length with documentation support.',
        landingSquareRect: 'Seamless stainless square & rectangular tubes (304/316L) supplied per project needs. Used for frames, racks, supports and structural applications. Cut-to-length with documentation support per order agreement.',
        applications: 'Explore typical applications across process piping, clean utilities, heat exchange and equipment manufacturing. We support material selection and delivery planning based on service conditions.',
        quality: 'Quality and delivery overview. Documentation packages are provided per order agreement, with focus on traceability, dimensional consistency and controllable delivery milestones.',
        news: 'Industry updates and observations on stainless markets and application trends.',
        contact: 'Contact HRWS for quotation and selection guidance. Please share grade, size, wall thickness, length, quantity, application/media and requested lead time.',
        privacy: 'Privacy and disclaimer information for this website.'
      }
    },
    common: {
      menu: 'Menu',
      langZh: '中文',
      langEn: 'EN'
    },
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      applications: 'Applications',
      quality: 'Quality',
      news: 'Insights',
      contact: 'Contact'
    },
    footer: {
      company: 'Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      rights: 'All rights reserved by hzhrws.com · seamless square & rectangular stainless tubing / BA seamless stainless tubing / EP electropolished stainless tubing',
      privacy: 'Privacy & Disclaimer'
    }
  }
}

const localeState = Vue.observable({
  locale: safeGetItem(LOCALE_KEY) || 'zh-CN'
})

function applyLocaleToDom(locale) {
  const lang = locale === 'en-US' ? 'en' : 'zh-CN'
  document.documentElement.lang = lang
  if (document.body) {
    document.body.classList.remove('lang-en', 'lang-zh')
    document.body.classList.add(locale === 'en-US' ? 'lang-en' : 'lang-zh')
  }
}

if (typeof document !== 'undefined') {
  applyLocaleToDom(localeState.locale)
}

function getByPath(obj, path) {
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj)
}

export function getLocale() {
  return localeState.locale
}

export function t(key) {
  const primary = getByPath(messages[localeState.locale], key)
  if (primary !== undefined) return primary
  const fallback = getByPath(messages['zh-CN'], key)
  return fallback !== undefined ? fallback : key
}

export function setLocale(locale) {
  if (!messages[locale]) return
  localeState.locale = locale
  safeSetItem(LOCALE_KEY, locale)
  applyLocaleToDom(locale)
  // Trigger a lightweight reflow for components that depend on content width/height.
  // IE11 / 360 兼容模式不支持 Event 构造函数，需走 createEvent
  dispatchCompatEvent(window, 'resize')
  dispatchCompatEvent(window, 'localechange')
}

function dispatchCompatEvent(target, name) {
  if (typeof window === 'undefined' || !target || !target.dispatchEvent) return
  try {
    if (typeof window.Event === 'function') {
      target.dispatchEvent(new window.Event(name))
      return
    }
  } catch (_) { /* IE */ }
  if (typeof document !== 'undefined' && document.createEvent) {
    const evt = document.createEvent('Event')
    evt.initEvent(name, true, true)
    target.dispatchEvent(evt)
  }
}

export default {
  messages,
  localeState,
  getLocale,
  setLocale,
  t
}
